<template>
  <div class="forgotten-password">
    <div class="heading-4 black--text">Forgot Password?</div>
    <div class="mt-8 text-5 darkgray--text">
      No worries! Enter your email address and you will receive a password reset
      link.
    </div>
    <ValidationObserver ref="observer">
      <form @submit.prevent="submit">
        <div class="mt-8 d-flex flex-column flex-sm-row align-sm-start">
          <div class="flex-1">
            <ValidationProvider
              v-slot="{ errors }"
              name="Email"
              rules="required|email"
            >
              <v-text-field
                autofocus
                id="email"
                placeholder="Email address"
                outlined
                single-line
                class="c-input"
                v-model="emailInput"
                type="email"
                required
                hide-details="auto"
                :error-messages="errors"
              />
            </ValidationProvider>
          </div>
          <input type="submit" class="d-none" />
          <div class="ml-sm-5 mt-3 mt-sm-0">
            <c-btn :loading="forgetPasswordState.isSubmitting" @click="submit"
              >Reset</c-btn
            >
          </div>
        </div>
        <div style="height: 30px" class="mt-3 text-5">
          <div class="error--text" v-if="forgetPasswordState.error">
            {{ forgetPasswordState.error.message }}
          </div>
          <div
            class="primary--text"
            v-if="
              !forgetPasswordState.isSubmitting &&
                forgetPasswordState.isSubmitted
            "
          >
            Password reset link has been sent!
          </div>
        </div>
        <div class="mt-3">
          <div
            class="text-4 primary--text clickable"
            @click="$emit('setComponent', 'LogIn')"
          >
            Go Back
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { required, email } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");
extend("required", {
  ...required,
  message: "{_field_} can not be empty.",
});
extend("email", {
  ...email,
  message: "Enter valid email address.",
});
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: ["email"],
  computed: mapGetters({
    forgetPasswordState: "auth/forgetPassword",
  }),
  data: () => ({
    emailInput: "",
  }),
  methods: {
    async submit() {
      const isFormValid = await this.$refs.observer.validate();
      if (!isFormValid) return;
      this.$store.dispatch("auth/forgetPassword", this.emailInput);
    },
  },
  mounted() {
    this.emailInput = this.email;
  },
};
</script>
